import { connect } from "react-redux";
import { default as component } from "./AddProjectSpecialNote.jsx";

// UI actions
import { dismissModal } from "../../../../common/UI/ActiveModal/duck/actions";
// UI selectors
import { getActiveModal } from "../../../../common/UI/ActiveModal/duck/selectors";

// Local selectors
import { getNewProjectSpecialNote } from "./duck/selectors";
import { getProjectID } from "../../../duck/selectors.js";

// Local actions
import {
  addProjectSpecialNoteUpdateNote,
  saveProjectSpecialNote,
} from "./duck/actions";

const mapStateToProps = (state) => {
  return {
    specialNote: getNewProjectSpecialNote(state),
    projectID: getProjectID(state),
    activeModal: getActiveModal(state),
  };
};

const mapDispatchToProps = {
  dismissModal,
  addProjectSpecialNoteUpdateNote,
  saveProjectSpecialNote,
};

export default connect(mapStateToProps, mapDispatchToProps)(component);
